import React from 'react';
import BaseSelectField from '../BaseSelectField';
import { useRoomStagesQuery } from '../../../../api/roomStages';
import { lifeCycleEntitiesMap, selectFieldNames } from '../../constants';
import { useAddressId } from '../../services/propsProvider';

const settings = {
  name: selectFieldNames[lifeCycleEntitiesMap.stage],
  label: 'Стадия',
};

const SelectStage = () => {
  const addressId = useAddressId();

  const { data, isFetching, refetch } = useRoomStagesQuery({
    params: { addressId },
  });

  return (
    <BaseSelectField
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      fetchErrMsg="Не удалось загрузить список доступных стадий"
      fieldSettings={settings}
    />
  );
};

export default SelectStage;
